import { combineReducers } from 'redux';
import { ACTIONS } from '../../_config';

import loaderReducer from './loaderReducer';
import userReducer from './userReducer';
import organizationReducer from './organizationReducer';
import menuToggleReducer from './menuToggleReducer';
import pusherReducer from './pushserReducer';

const appReducer = combineReducers({
	loader: loaderReducer,
	user: userReducer,
	menu: menuToggleReducer,
	pusher: pusherReducer,
	// organization:organizationReducer,
})

const rootReducer = (state: any, action: any) => {
	if (action.type === ACTIONS.RESET_REDUCER) {
		state = undefined;
		localStorage.removeItem('persist:root');
	}

	return appReducer(state, action)
	
}

export default rootReducer